import React from "react";

const ReviewAnimationLoadingSection: React.FC = () => {
    return (
        <div>
            <p>Loading... This may take a few minutes. Hold tight!</p>
        </div>
    );
};

export default ReviewAnimationLoadingSection;
